module.exports = __webpack_public_path__ + "img/OnlineWallet.7b377f51.svg";